import { render } from "./Sconto.vue?vue&type=template&id=c8d5f770&ts=true"
import script from "./Sconto.vue?vue&type=script&lang=ts"
export * from "./Sconto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__